import React from 'react';
import Layout from '../components/Layout';
import '../styles/service-page.css';

const ProcessFlows = ({ user }) => {
  return (
    <Layout>
      <div className="container service-page">
        <div className="page-heading">
          <h1>Process Flows</h1>
          <p>Map out your business processes, workflows, and operational procedures with clarity and precision. Transform complex business logic into visual workflows that teams can understand and follow.</p>
        </div>

        <div className="service-content">
          <div className="overview-section">
            <h2>Business Process Visualization</h2>
            <p>Our process flow service helps organizations document, analyze, and optimize their business processes. Whether you're streamlining operations, onboarding new team members, or ensuring compliance, clear process documentation is essential.</p>
          </div>

          <div className="process-types">
            <h2>Types of Process Flows</h2>
            <div className="types-grid">
              <div className="type-item">
                <h3>Business Processes</h3>
                <p>Document core business operations, from customer onboarding to order fulfillment and support workflows.</p>
              </div>
              <div className="type-item">
                <h3>Operational Procedures</h3>
                <p>Create step-by-step guides for routine operations, maintenance procedures, and quality control processes.</p>
              </div>
              <div className="type-item">
                <h3>Decision Trees</h3>
                <p>Map complex decision-making processes with clear branching logic and outcome paths.</p>
              </div>
              <div className="type-item">
                <h3>Approval Workflows</h3>
                <p>Document approval chains, escalation procedures, and governance processes.</p>
              </div>
              <div className="type-item">
                <h3>Customer Journeys</h3>
                <p>Visualize customer touchpoints, interactions, and experience flows across your organization.</p>
              </div>
              <div className="type-item">
                <h3>Compliance Processes</h3>
                <p>Ensure regulatory compliance with documented procedures and audit trails.</p>
              </div>
            </div>
          </div>

          <div className="benefits-section">
            <h2>Process Flow Benefits</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h3>Operational Clarity</h3>
                <p>Eliminate confusion and reduce errors by making processes crystal clear for all team members.</p>
              </div>
              <div className="benefit-item">
                <h3>Efficiency Gains</h3>
                <p>Identify bottlenecks, redundancies, and optimization opportunities in your workflows.</p>
              </div>
              <div className="benefit-item">
                <h3>Training & Onboarding</h3>
                <p>Accelerate new employee onboarding with visual process guides and standard operating procedures.</p>
              </div>
              <div className="benefit-item">
                <h3>Compliance & Audit</h3>
                <p>Demonstrate process adherence and maintain audit trails for regulatory requirements.</p>
              </div>
            </div>
          </div>

          <div className="applications">
            <h2>Common Applications</h2>
            <div className="applications-list">
              <div className="application">
                <h3>Manufacturing</h3>
                <p>Production workflows, quality control procedures, and safety protocols.</p>
              </div>
              <div className="application">
                <h3>Healthcare</h3>
                <p>Patient care pathways, treatment protocols, and administrative procedures.</p>
              </div>
              <div className="application">
                <h3>Financial Services</h3>
                <p>Loan approval processes, risk assessment workflows, and compliance procedures.</p>
              </div>
              <div className="application">
                <h3>Software Development</h3>
                <p>Development workflows, deployment processes, and incident response procedures.</p>
              </div>
              <div className="application">
                <h3>Customer Service</h3>
                <p>Support ticket workflows, escalation procedures, and resolution processes.</p>
              </div>
              <div className="application">
                <h3>Human Resources</h3>
                <p>Hiring processes, performance reviews, and employee lifecycle management.</p>
              </div>
            </div>
          </div>

          <div className="features-section">
            <h2>Process Flow Features</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Interactive Elements</h3>
                <p>Create clickable process maps with detailed information and linked resources.</p>
              </div>
              <div className="feature-item">
                <h3>Role-Based Views</h3>
                <p>Show different perspectives of the same process for different stakeholders.</p>
              </div>
              <div className="feature-item">
                <h3>Performance Metrics</h3>
                <p>Integrate KPIs and performance indicators directly into your process diagrams.</p>
              </div>
              <div className="feature-item">
                <h3>Version Control</h3>
                <p>Track process changes over time and maintain historical versions for compliance.</p>
              </div>
            </div>
          </div>

          <div className="methodology">
            <h2>Our Process Mapping Methodology</h2>
            <div className="methodology-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Process Discovery</h3>
                  <p>Identify and catalog all processes within the scope of your project.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Current State Mapping</h3>
                  <p>Document how processes currently work, including pain points and inefficiencies.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Analysis & Optimization</h3>
                  <p>Identify improvement opportunities and design optimized future state processes.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Implementation Support</h3>
                  <p>Provide documentation and training materials to support process implementation.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <h2>Optimize Your Processes</h2>
            <p>Ready to bring clarity to your business processes? Our AI-powered process flow service helps you create clear, actionable process documentation that drives operational excellence.</p>
            <button className="cta-button">Start Process Mapping</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProcessFlows;